export default __webpack_public_path__ + "static/media/hero-background.182a0bbc.jpg";